module.exports = __webpack_public_path__ + "img/x-square.e0c45b70.svg";